'use strict';

import {validation} from './validation';
import XRegExp from 'xregexp';

function createValidation(element) {
  var regexp = XRegExp.cache(element.getAttribute('data-pattern'));
  var options = {
    onValid: function() {
      element.classList.add('u-hidden')
    },
    onInvalid: function() {
      element.classList.remove('u-hidden')
    }
  };

  return validation.create(function(value) {
    return regexp.test(value);
  }, options);
}

function createValidationsFrom(elements) {
  var result = [];
  [].forEach.call(elements, function(element) {
    result.push(createValidation(element));
  });

  return result;
}

export var passwordValidation = {
  createValidationsFrom: createValidationsFrom
};
